  <div class="telemetry-container">

    <div class="telemetry-header">
      <div class="telemetry-title">
        <button class="back-btn" (click)="voltar()">
          <i class="pi pi-arrow-left"></i>
        </button>
        <h2>{{ 'vcuTelemetry.title' | transloco }} — <span class="serial">{{ vcuNickname || serialNumber }}</span></h2>
        <span class="live-indicator live-indicator--live" *ngIf="isLiveMode && liveStatus === 'live'">
          <span class="live-dot"></span> {{ 'vcuTelemetry.live' | transloco }}
        </span>
        <span class="live-indicator live-indicator--stale" *ngIf="isLiveMode && liveStatus === 'stale'">
          <i class="pi pi-clock"></i> {{ 'vcuTelemetry.lastState' | transloco }} — {{ liveLastDataTime }}
        </span>
        <span class="live-indicator live-indicator--offline" *ngIf="isLiveMode && liveStatus === 'offline'">
          <i class="pi pi-wifi"></i> {{ 'vcuTelemetry.offline' | transloco }}
        </span>
      </div>
    </div>

    <div class="filter-bar">
      <div class="filter-group">
        <label>{{ 'vcuTelemetry.startDate' | transloco }}</label>
        <p-calendar
          [(ngModel)]="startDate"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [showOnFocus]="false"
          [showTime]="true"
          [hourFormat]="'24'"
          appendTo="body"
          [disabled]="isLiveMode"
          [placeholder]="'vcuTelemetry.startDatePlaceholder' | transloco" />
      </div>

      <div class="filter-group">
        <label>{{ 'vcuTelemetry.endDate' | transloco }}</label>
        <p-calendar
          [(ngModel)]="endDate"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [showOnFocus]="false"
          [showTime]="true"
          [hourFormat]="'24'"
          appendTo="body"
          [disabled]="isLiveMode"
          [placeholder]="'vcuTelemetry.endDatePlaceholder' | transloco" />
      </div>

      <div class="filter-group">
        <label>{{ 'vcuTelemetry.interval' | transloco }}</label>
        <p-dropdown
          [options]="intervalOptions"
          [(ngModel)]="selectedInterval"
          optionLabel="label"
          appendTo="body"
          [disabled]="isLiveMode"
          [placeholder]="'vcuTelemetry.intervalPlaceholder' | transloco" />
      </div>

      <div class="filter-group filter-action">
        <p-button
          [label]="'vcuTelemetry.search' | transloco"
          icon="pi pi-search"
          [loading]="isLoading"
          [disabled]="isLiveMode"
          (onClick)="buscarTelemetria()" />
        <p-button
          [label]="isLiveMode ? ('vcuTelemetry.stop' | transloco) : ('vcuTelemetry.goLive' | transloco)"
          [icon]="isLiveMode ? 'pi pi-stop-circle' : 'pi pi-wifi'"
          [severity]="isLiveMode ? 'danger' : 'success'"
          [loading]="isConnecting"
          (onClick)="toggleLive()" />
      </div>
    </div>

    <div class="loading-state" *ngIf="isLoading">
      <p-progressSpinner styleClass="medium-spinner" />
      <span>{{ 'vcuTelemetry.loading' | transloco }}</span>
    </div>

    <div class="error-state" *ngIf="hasError && !isLoading">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <div class="live-offline-state" *ngIf="isLiveMode && liveStatus === 'offline'">
      <i class="pi pi-wifi"></i>
      <span>{{ 'vcuTelemetry.vcuOfflineMsg' | transloco }}</span>
      <small>{{ 'vcuTelemetry.vcuOfflineHint' | transloco }}</small>
    </div>

    <ng-container *ngIf="!isLoading && !hasError && hasSearched">

      <div class="empty-state" *ngIf="!hasData">
        <i class="pi pi-chart-line"></i>
        <span>{{ 'vcuTelemetry.noData' | transloco }}</span>
      </div>

      <div class="empty-state" *ngIf="hasData && channels.length === 0">
        <i class="pi pi-info-circle"></i>
        <span>{{ 'vcuTelemetry.noNumericChannels' | transloco: { count: totalCount } }}</span>
      </div>

      <ng-container *ngIf="channels.length > 0">
        <div class="channels-section">
          <span class="channels-label">{{ 'vcuTelemetry.availableChannels' | transloco }}</span>
          <div class="channels-list">
            <button
              *ngFor="let channel of channels"
              class="channel-toggle"
              [class.active]="channel.enabled"
              (click)="toggleChannel(channel)">
              {{ channel.label }}
            </button>
          </div>
        </div>

        <div class="chart-wrapper">
          <p-chart
            type="line"
            [data]="chartData"
            [options]="chartOptions"
            height="420px" />
        </div>
      </ng-container>

    </ng-container>

  </div>
